import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminBuildings = z.any()
export type TagsGetAdminBuildings = z.infer<typeof tagsGetAdminBuildings>

export const responseGetAdminBuildings = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "address": z.string().optional(), "municipality": z.object({ "id": z.string(), "name": z.string() }), "collectionPointCount": z.number() })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminBuildings = z.infer<typeof responseGetAdminBuildings>

interface IGetAdminBuildings extends BaseMethodType {
  tags: TagsGetAdminBuildings,
  response: ResponseGetAdminBuildings
}
export const URL = '/admin/buildings'
export const validation = {
  get: {
    tags: tagsGetAdminBuildings,
    response: responseGetAdminBuildings
  }
}
export interface AdminBuildings extends BaseRouteType {
  get: IGetAdminBuildings
}